<template>
    <div>
        <CRow
        ><CCol tag="label" class="col-form-label">График работы</CCol></CRow
        >
        <div class="store-schedule">
            <CRow
                v-for="(day, index) of schedule"
                :key="index"
                class="store-schedule-item"
            >
                <CRow class="store-schedule-enable" style="margin-bottom: 10px;">
                    <span>{{ daysOfTheWeek[index] }}</span>
                    <CSwitch
                        name="dayEnabled"
                        color="dark"
                        shape="pill"
                        variant="opposite"
                        :checked.sync="day.enabled"
                        disabled
                    />
                </CRow>
                <CRow v-if="day.stop_until" class="store-schedule-warn__text pt-2">
                    {{ getTimeRemaining(day.stop_until) }}
                </CRow>
            </CRow>
        </div>
    </div>
</template>

<script>
    import { DAYS_OF_THE_WEEK, SCHEDULE } from '../utils/schedule';
    import moment from 'moment';
    
    export default {
        props: {
            schedule: {
                type: Array,
                default: ()=>{ return SCHEDULE },
            },
        },

        data: () => ({
            daysOfTheWeek: DAYS_OF_THE_WEEK,
        }),

        methods: {
            getTimeRemaining(date) {
                const dt = moment(date);
                if (moment().isSameOrBefore(dt)) {
                    return `Приостановлен до ${dt.format('HH:mm')}`;
                }
                return '';
            }
        }
    };
</script>
<style scoped>
.store-schedule-warn__text {
    color: red;
    font-weight: bold;
}
</style>
